import { ChangeDetectionStrategy, Component, inject, NgZone } from '@angular/core';

// NG-ZORRO Modules
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';

export interface ErrorModalData {
  title?: string;
  message?: string;
}

@Component({
  selector: 'app-error-handle-component',
  standalone: true,
  imports: [NzButtonModule, NzIconModule],
  templateUrl: './error-handle-component.html',
  styleUrls: ['./error-handle-component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorHandleComponent {
  private readonly modalRef = inject(NzModalRef);
  private readonly modalData = inject<ErrorModalData>(NZ_MODAL_DATA);

  // Injecting NgZone for UI thread safety when closing modals
  private readonly ngZone = inject(NgZone);

  public readonly title = this.modalData?.title || 'System Error';
  public readonly message =
    this.modalData?.message || 'An unexpected error occurred. Please try again.';

  public close(): void {
    this.ngZone.run(() => {
      this.modalRef.close();
    });
  }
}
